import React from 'react';
import { Link } from 'react-router-dom';

import Manager from '../managers/manager';
import { supStyle } from './utils';
import { ManagerPermission } from '../permission-profiles/permission';

interface FeatureButtonProps {
    title: string;
    linkTo: string;
    manager: Manager;
    restrictedToFeatures: ManagerPermission[];
    counter?: string;
    state?: { [stateKey: string]: string | number };
}

export default function FeatureButton(props: FeatureButtonProps) {
    const { manager, restrictedToFeatures } = props;
    let hasFeature = false;
    for (const feature of restrictedToFeatures) {
        if (manager?.profile?.permissions.includes(feature)) {
            hasFeature = true;
            break;
        }
    }
    const button = (
        <Link className="ml2" state={props.state} to={props.linkTo}>
            <button className="wfp-btn" type="button">
                {props.title}
                {props.counter && Number(props.counter) > 0 && <sup style={supStyle}>{props.counter}</sup>}
            </button>
        </Link>
    );
    return hasFeature ? button : null;
}
